const METADATA_KEYS = ["$initial_person_info", "$initial_referrer_info", "$initial_campaign_params", "$stored_person_properties"]

function plainMetadata(value) {
  if (!value || typeof value !== "object" || Array.isArray(value)) return false
  const prototype = Object.getPrototypeOf(value)
  return prototype === Object.prototype || prototype === null
}

export function failClosedPostHogPrivacy(instance) {
  try {
    instance.set_config({
      advanced_disable_flags: true,
      disable_session_recording: true,
      capture_pageview: false,
      autocapture: false,
      before_send: () => null,
    })
  } catch {
    // Analytics failures must never prevent the application from opening.
  }
  return false
}

export function sanitizeLoadedPostHogPersistence(instance, sanitizeObject, sanitizeUrl, currentMetadata) {
  try {
    const cleanMetadata = value => {
      if (!plainMetadata(value)) throw new Error("invalid_analytics_metadata")
      const clean = sanitizeObject(value)
      if (!plainMetadata(clean)) throw new Error("invalid_analytics_metadata")
      for (const key of ["u", "r"]) {
        if (Object.hasOwn(clean, key)) {
          if (typeof clean[key] !== "string") throw new Error("invalid_analytics_url_metadata")
          clean[key] = sanitizeUrl(clean[key])
        }
      }
      return clean
    }
    const registerVerified = (key, value) => {
      instance.register({ [key]: value })
      if (JSON.stringify(instance.get_property(key)) !== JSON.stringify(value)) throw new Error("analytics_metadata_not_saved")
    }
    for (const key of METADATA_KEYS) {
      const previous = instance.get_property(key)
      if (previous !== undefined && previous !== null) registerVerified(key, cleanMetadata(previous))
    }
    const hasFirstTouch = METADATA_KEYS.slice(0, 3).some(key => instance.get_property(key) != null)
    if (!hasFirstTouch) {
      const metadata = currentMetadata()
      if (typeof metadata?.u !== "string") throw new Error("missing_analytics_url_metadata")
      registerVerified("$initial_person_info", cleanMetadata(metadata))
    }
    return true
  } catch {
    return failClosedPostHogPrivacy(instance)
  }
}
